/* CollecteAvis — page « Audit gratuit » (refonte 2026-10, session 14).
   Lit la note et le nombre d'avis d'une fiche Google en direct (API Places du site, clé restreinte à collecteavis.fr).
   Le script Google ne se charge qu'au premier toucher d'un champ. Rien n'est enregistré. */
(function () {
  var outil = document.querySelector('[data-au-outil]');
  if (!outil) return;
  var CLE = outil.getAttribute('data-cle');
  var REF = outil.getAttribute('data-ref') || 'SITE-AUDIT';
  var DEBUT = outil.getAttribute('data-message') || 'Bonjour, je voudrais le diagnostic gratuit de ma fiche Google.';
  var calme = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var fiches = { 1: null, 2: null };
  var auto = null, details = null, jeton = null, chargement = null;

  function $(sel, racine) { return (racine || outil).querySelector(sel); }
  function champ(n) { return $('[data-au="' + n + '"]'); }
  function fr(n, d) { return Number(n).toLocaleString('fr-FR', { minimumFractionDigits: d || 0, maximumFractionDigits: d || 0 }); }

  /* Charger Google une seule fois, à la demande */
  function chargerGoogle() {
    if (chargement) return chargement;
    chargement = new Promise(function (ok, ko) {
      if (window.google && google.maps && google.maps.places) return ok();
      window.caAuditPret = function () { ok(); };
      var s = document.createElement('script');
      s.src = 'https://maps.googleapis.com/maps/api/js?key=' + encodeURIComponent(CLE) + '&libraries=places&v=weekly&language=fr&callback=caAuditPret';
      s.async = true;
      s.onerror = ko;
      document.head.appendChild(s);
      setTimeout(ko, 12000);
    }).then(function () {
      auto = new google.maps.places.AutocompleteService();
      details = new google.maps.places.PlacesService(document.createElement('div'));
    });
    chargement.catch(erreur);
    return chargement;
  }
  function nouveauJeton() { jeton = new google.maps.places.AutocompleteSessionToken(); }
  function erreur() { var e = $('[data-au-erreur]'); if (e) e.hidden = false; }

  /* Un champ de recherche avec ses suggestions */
  function brancher(n) {
    var bloc = $('[data-au-champ="' + n + '"]');
    var input = bloc.querySelector('input');
    var liste = bloc.querySelector('.au-liste');
    var minuterie = null, choix = -1, suggestions = [];

    function fermer() { liste.hidden = true; input.setAttribute('aria-expanded', 'false'); choix = -1; }
    function surligner(i) {
      var items = liste.children;
      for (var k = 0; k < items.length; k++) items[k].setAttribute('aria-selected', k === i ? 'true' : 'false');
      choix = i;
    }
    function remplir(preds) {
      suggestions = preds || [];
      liste.innerHTML = '';
      if (!suggestions.length) { fermer(); return; }
      suggestions.slice(0, 5).forEach(function (p, i) {
        var li = document.createElement('li');
        li.setAttribute('role', 'option');
        li.id = 'au-opt-' + n + '-' + i;
        var b = document.createElement('b');
        b.textContent = p.structured_formatting ? p.structured_formatting.main_text : p.description;
        var s = document.createElement('span');
        s.textContent = p.structured_formatting ? (p.structured_formatting.secondary_text || '') : '';
        li.appendChild(b); li.appendChild(s);
        li.addEventListener('mousedown', function (e) { e.preventDefault(); prendre(i); });
        liste.appendChild(li);
      });
      liste.hidden = false;
      input.setAttribute('aria-expanded', 'true');
    }
    function prendre(i) {
      var p = suggestions[i];
      if (!p) return;
      input.value = p.structured_formatting ? p.structured_formatting.main_text : p.description;
      fermer();
      input.blur();
      bloc.classList.add('cherche');
      details.getDetails({ placeId: p.place_id, fields: ['name', 'rating', 'user_ratings_total', 'formatted_address', 'reviews'], sessionToken: jeton }, function (place, statut) {
        bloc.classList.remove('cherche');
        nouveauJeton();
        if (statut !== google.maps.places.PlacesServiceStatus.OK || !place) { erreur(); return; }
        afficher({ nom: place.name, adresse: place.formatted_address, note: place.rating || 0, avis: place.user_ratings_total || 0, notes: (place.reviews || []).map(function (r) { return r.rating; }).filter(function (x) { return x; }), avisListe: place.reviews || [], placeId: p.place_id }, n);
      });
    }
    input.addEventListener('focus', function () {
      chargerGoogle().then(function () { if (!jeton) nouveauJeton(); });
      /* Au téléphone, le clavier cache le bas de l'écran : on remonte le champ en haut pour que les suggestions restent visibles */
      if (window.innerWidth < 750) setTimeout(function () {
        var haut = input.getBoundingClientRect().top + window.pageYOffset - 96;
        window.scrollTo({ top: Math.max(0, haut), behavior: calme ? 'auto' : 'smooth' });
      }, 250);
    });
    input.addEventListener('input', function () {
      var v = input.value.trim();
      clearTimeout(minuterie);
      if (v.length < 2) { fermer(); return; }
      minuterie = setTimeout(function () {
        chargerGoogle().then(function () {
          if (!jeton) nouveauJeton();
          auto.getPlacePredictions({ input: v, types: ['establishment'], componentRestrictions: { country: ['fr', 'be'] }, sessionToken: jeton }, function (preds, statut) {
            var S = google.maps.places.PlacesServiceStatus;
            if (statut !== S.OK && statut !== S.ZERO_RESULTS) { fermer(); erreur(); return; }
            remplir(preds);
          });
        });
      }, 220);
    });
    input.addEventListener('keydown', function (e) {
      if (liste.hidden) return;
      var max = liste.children.length - 1;
      if (e.key === 'ArrowDown') { e.preventDefault(); surligner(choix < max ? choix + 1 : 0); }
      else if (e.key === 'ArrowUp') { e.preventDefault(); surligner(choix > 0 ? choix - 1 : max); }
      else if (e.key === 'Enter') { e.preventDefault(); prendre(choix >= 0 ? choix : 0); }
      else if (e.key === 'Escape') { fermer(); }
    });
    input.addEventListener('blur', function () { setTimeout(fermer, 150); });
  }

  /* Les chiffres montent doucement jusqu'à leur valeur */
  function compter(el, fin, decimales) {
    if (!el) return;
    if (calme) { el.textContent = fr(fin, decimales); return; }
    var t0 = null, duree = 900;
    function pas(t) {
      if (!t0) t0 = t;
      var k = Math.min(1, (t - t0) / duree), e = 1 - Math.pow(1 - k, 3);
      el.textContent = fr(fin * e, decimales);
      if (k < 1) requestAnimationFrame(pas);
    }
    requestAnimationFrame(pas);
  }

  /* Le prochain palier : combien d'avis à 5 étoiles pour l'atteindre (note Google arrondie : « environ ») */
  function palier(f) {
    if (!f.avis) return 'Votre premier avis à 5 étoiles vous mettra <b>à 5,0</b>.';
    var cibles = [4, 4.5, 4.8], r = f.note, n = f.avis, t = null;
    for (var i = 0; i < cibles.length; i++) if (r < cibles[i] - 0.04) { t = cibles[i]; break; }
    if (t === null) return 'Votre note est déjà <b>excellente</b>. Le plus dur, maintenant, c’est de la garder.';
    var k = Math.max(1, Math.ceil(n * (t - r) / (5 - t)));
    return 'Pour passer de ' + fr(r, 1) + ' à ' + fr(t, 1) + ', il vous faut <b>environ ' + fr(k) + ' avis à 5 étoiles</b>.';
  }
  /* Les avis que Google montre en premier sur la fiche (les « plus pertinents ») : leurs notes seulement, jamais les noms ni le texte */
  function lus(f) {
    var bloc = champ('lus'), notes = (f.notes || []).slice(0, 5);
    if (!notes.length) { bloc.hidden = true; return; }
    var etoile = '<svg viewBox="0 0 24 24"><path d="M12 3.5l2.6 5.3 5.9.9-4.3 4.1 1 5.8L12 16.9l-5.2 2.7 1-5.8-4.3-4.1 5.9-.9z"/></svg>';
    bloc.querySelector('.au-lus__titre').textContent = notes.length > 1 ? 'Les ' + notes.length + ' avis que Google met en avant' : 'L’avis que Google met en avant';
    champ('pastilles').innerHTML = notes.map(function (x) {
      return '<span class="au-pastille au-pastille--' + (x >= 4 ? 'bien' : x === 3 ? 'moyen' : 'mal') + '">' + x + etoile + '</span>';
    }).join('');
    var bien = notes.filter(function (x) { return x >= 4; }).length, mal = notes.filter(function (x) { return x <= 2; }).length, t = notes.length, ph;
    if (mal) ph = (mal > 1 ? '<b>' + mal + ' avis négatifs</b> sont' : '<b>1 avis négatif</b> est') + ' mis en avant sur votre fiche. Une réponse calme et polie le désamorce. <a href="/blogs/actualites/supprimer-avis-google">Comment répondre</a>';
    else if (bien === t && f.note >= 4) ph = 'Ils sont <b>tous positifs</b> : c’est votre vitrine.';
    else if (bien === t) ph = 'Ils sont positifs, mais <b>votre note de ' + fr(f.note, 1) + '</b> montre que d’autres le sont moins. Chaque nouvel avis content la fait remonter.';
    else ph = '<b>' + bien + ' sur ' + t + '</b> sont positifs, les autres sont mitigés.';
    champ('lus-phrase').innerHTML = ph;
    /* Un seul extrait : le meilleur des avis mis en avant (le plus haut noté, puis le plus long), avec la photo de son auteur
       (minimum exigé par Google) et l'accès à la fiche sur Google Maps. Aucun appel en plus : tout est dans la même réponse. */
    var ex = champ('extrait'), liste = (f.avisListe || []).filter(function (r) { return r.text && r.rating >= 4 && r.profile_photo_url; });
    liste.sort(function (x, y) { return (y.rating - x.rating) || (y.text.length - x.text.length); });
    var meilleur = liste[0];
    if (meilleur && f.placeId) {
      var txt = meilleur.text.replace(/\s+/g, ' ').trim();
      if (txt.length > 140) txt = txt.slice(0, 140).replace(/\s+\S*$/, '') + '…';
      champ('extrait-texte').textContent = '« ' + txt + ' »';
      var ph2 = champ('extrait-photo');
      ph2.src = meilleur.profile_photo_url;
      champ('extrait-lien').href = 'https://www.google.com/maps/place/?q=place_id:' + encodeURIComponent(f.placeId);
      ex.hidden = false;
    } else ex.hidden = true;
    bloc.hidden = false;
  }

  /* La note après un seul avis à 1 étoile */
  function apresUnAvis(f) { return f.avis ? Math.round(((f.note * f.avis + 1) / (f.avis + 1)) * 10) / 10 : 1; }

  function afficher(f, n) {
    fiches[n] = f;
    if (n === 1) {
      var vide = $('[data-au-vide]'), fiche = $('[data-au-fiche]');
      champ('nom').textContent = f.nom;
      champ('adresse').textContent = f.adresse || '';
      vide.hidden = true;
      fiche.hidden = false;
      fiche.classList.remove('vu'); void fiche.offsetWidth; fiche.classList.add('vu');
      if (f.note) compter(champ('note'), f.note, 1); else champ('note').textContent = '–';
      compter(champ('avis'), f.avis, 0);
      champ('etoiles').style.width = (f.note ? (f.note / 5) * 100 : 0) + '%';
      lus(f);
      var pal = champ('palier'); pal.innerHTML = palier(f); pal.hidden = false;
      var cmp = $('[data-au-compare]');
      if (cmp.hidden) { cmp.hidden = false; cmp.classList.add('vu'); }
      lienWhatsApp(f);
    }
    if (fiches[1] && fiches[2]) duel();
  }

  function duel() {
    var a = fiches[1], b = fiches[2], d = $('[data-au-duel]');
    var max = Math.max(a.avis, b.avis, 1);
    champ('duel-nom-1').textContent = a.nom;
    champ('duel-nom-2').textContent = b.nom;
    champ('duel-avis-1').textContent = fr(a.avis) + ' avis';
    champ('duel-avis-2').textContent = fr(b.avis) + ' avis';
    var ecart = b.avis - a.avis, phrase;
    if (a.nom === b.nom && a.adresse === b.adresse) phrase = 'C’est <b>le même commerce</b> : choisissez un voisin.';
    else if (ecart > 0) phrase = 'Votre voisin a <b>' + fr(ecart) + ' avis de plus</b> que vous.';
    else if (ecart < 0) phrase = 'Vous avez <b>' + fr(-ecart) + ' avis d’avance</b> sur votre voisin.';
    else phrase = 'Vous avez <b>autant d’avis</b> que votre voisin.';
    champ('duel-phrase').innerHTML = phrase;
    var fragile = champ('fragile');
    fragile.hidden = !(a.avis && b.avis && a.note && b.note);
    var a2 = apresUnAvis(a), b2 = apresUnAvis(b);
    champ('frag-nom-1').textContent = a.nom; champ('frag-nom-2').textContent = b.nom;
    champ('frag-avant-1').textContent = a.note ? fr(a.note, 1) : '–'; champ('frag-apres-1').textContent = fr(a2, 1);
    champ('frag-avant-2').textContent = b.note ? fr(b.note, 1) : '–'; champ('frag-apres-2').textContent = fr(b2, 1);
    var pa = Math.round((a.note - a2) * 10) / 10, pb = Math.round((b.note - b2) * 10) / 10, fp;
    if (!a.avis) fp = 'Sans avis, <b>le premier avis décide de toute votre note</b>. Plus une fiche a d’avis, plus sa note est solide.';
    else if (pa > pb) fp = 'Un seul avis à 1 étoile vous coûterait <b>' + fr(pa, 1) + ' point</b>' + (pb > 0 ? ', à lui seulement ' + fr(pb, 1) + '.' : ', à lui presque rien.') + ' Plus une fiche a d’avis, plus sa note est solide.';
    else if (pa < pb) fp = 'Votre note résiste mieux que la sienne : <b>plus une fiche a d’avis, plus sa note est solide.</b>';
    else fp = 'Vos deux notes réagiraient pareil. <b>Plus une fiche a d’avis, plus sa note est solide.</b>';
    champ('frag-phrase').innerHTML = fp;
    d.hidden = false;
    var b1 = champ('barre-1'), b2 = champ('barre-2');
    b1.style.width = '0%'; b2.style.width = '0%';
    void d.offsetWidth;
    requestAnimationFrame(function () {
      b1.style.width = Math.max(2, (a.avis / max) * 100) + '%';
      b2.style.width = Math.max(2, (b.avis / max) * 100) + '%';
    });
  }

  function lienWhatsApp(f) {
    var a = document.querySelector('[data-au-wa]');
    if (!a) return;
    var txt = DEBUT + '\nCommerce : ' + f.nom + (f.adresse ? '\nAdresse : ' + f.adresse : '') + '\n(réf. ' + REF + ')';
    a.href = 'https://wa.me/33788000621?text=' + encodeURIComponent(txt);
    var note = document.querySelector('[data-au-wa-note]');
    if (note) note.textContent = 'Le nom et l’adresse de « ' + f.nom + ' » sont déjà dans le message.';
    var mail = document.querySelector('[data-au-mail]');
    if (mail) mail.href = 'mailto:contact@collecteavis.fr?subject=' + encodeURIComponent('Diagnostic gratuit de ma fiche Google') + '&body=' + encodeURIComponent('Bonjour, je voudrais le diagnostic gratuit de ma fiche Google.\nCommerce : ' + f.nom + (f.adresse ? '\nAdresse : ' + f.adresse : '') + '\n(réf. SITE-AUDIT-MAIL)');
  }

  brancher(1);
  brancher(2);
  window.caAudit = { afficher: afficher };
})();
